import { Spinner, Text, VStack } from "@chakra-ui/react";
import React from "react";

const Loader = ({ text }) => {
  return (
    <VStack
      spacing={4}
      direction={"column"}
      flexGrow={1}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Spinner
        size="xl"
        color="brand.secondary.500"
        thickness="3px"
        speed="0.65s"
      />
      <Text color={"white"}>{text}</Text>
    </VStack>
  );
};

export default Loader;
